import { useCallback, useEffect, useState } from 'react';
import { qrGetPublic } from './qrPublicApi';

const PAGE = 50;

export function BoundPassportsList({ token, refreshKey }) {
  const [q, setQ] = useState('');
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState({ total: 0, items: [] });

  const load = useCallback(() => {
    const p = new URLSearchParams({ limit: PAGE, offset });
    if (q) p.set('q', q);
    qrGetPublic(`/d/${token}/bindings?${p}`).then(setData).catch(() => setData({ total: 0, items: [] }));
  }, [token, q, offset]);

  useEffect(() => { load(); }, [load, refreshKey]);
  useEffect(() => { setOffset(0); }, [q]);

  return (
    <section className="rounded-xl bg-white border p-4" style={{ borderColor: '#E5E3DC' }} data-testid="bound-passports">
      <div className="flex items-center gap-2 mb-3">
        <h2 className="font-semibold text-base mr-auto">Passports on this device <span className="text-slate-400 font-normal">({data.total})</span></h2>
        <input data-testid="bound-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Short code"
          className="h-8 w-32 rounded border px-2 text-sm" style={{ borderColor: '#D9D6CD' }} />
      </div>
      {data.items.length === 0 ? <p className="text-sm text-slate-400">Nothing bound{q ? ' matching that code' : ' yet'}.</p> : (
        <ul className="divide-y text-sm" style={{ borderColor: '#F3F1EA' }}>
          {data.items.map(b => (
            <li key={b.binding_id} className="py-2 flex items-center gap-2" data-testid={`bound-${b.short_code}`}>
              <span className="font-mono font-semibold">{b.short_code}</span>
              {b.parent_short_code && <span className="text-xs text-slate-500">in {b.parent_short_code}</span>}
              <span className="ml-auto text-xs text-slate-400">{new Date(b.bound_at).toLocaleString('en-IN', { dateStyle: 'short', timeStyle: 'short' })}</span>
            </li>
          ))}
        </ul>
      )}
      {data.total > PAGE && (
        <div className="flex justify-end gap-2 mt-3 text-xs">
          <button disabled={offset === 0} onClick={() => setOffset(o => o - PAGE)} className="px-3 py-1 rounded border disabled:opacity-40">Prev</button>
          <button disabled={offset + PAGE >= data.total} onClick={() => setOffset(o => o + PAGE)} className="px-3 py-1 rounded border disabled:opacity-40">Next</button>
        </div>
      )}
    </section>
  );
}
